import Swiper, { Pagination } from 'swiper';
import 'swiper/css';
const statsSwipers = document.querySelectorAll('.stats--swiper');
window.addEventListener('load', (e) => {
	statsSwipers.forEach((statsSwiper) => {
		let statsSwiperInit = new Swiper(statsSwiper, {
			modules: [Pagination],
			slidesPerView: 1.2,
			spaceBetween: 30,
			pagination: {
				el: statsSwiper.querySelector('.swiper-pagination'),
				clickable: true,
			},
			breakpoints: {
				900: {
					slidesPerView: 2.5,
					slidesPerGroup: 2,
				},
				1200: {
					slidesPerView: 3,
					slidesPerGroup: 2,
				},
				1500: {
					slidesPerView: 4,
				},
			},
		});
	});
});
